export default "__VITE_ASSET__qCeS8Kfa__"